import { createSelector } from 'reselect';

const selectMarketingEmailPlans = (state: any) => state.marketingEmailPlans;


export const selectMarketingEmailPlansCurrentItem = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.current);

export const selectMarketingEmailPlansListItems = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectMarketingEmailPlansListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMarketingEmailPlansQueryItems = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.query);

export const selectMarketingEmailPlansCreatedItem = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.create);

export const selectMarketingEmailPlansUpdatedItem = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.update);

export const selectMarketingEmailPlansReadItem = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.read);

export const selectMarketingEmailPlansDeletedItem = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.delete);

export const selectMarketingEmailPlansSearchedItems = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.search);

export const selectMarketingEmailPlansItemsCount = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.count);

export const selectMarketingEmailPlansItemsFilter = createSelector([selectMarketingEmailPlans], (marketingEmailPlans) => marketingEmailPlans.filter);